/**
 * Memorable username generator: adjective_noun_### format.
 * Pools mirror the SQL handle_new_user() trigger so client and DB stay in sync.
 */

export const USERNAME_ADJECTIVES = [
  "cozy", "modern", "rustic", "golden", "velvet", "urban", "serene", "bold", "minimal", "lush",
  "warm", "soft", "bright", "sleek", "classic", "vintage", "airy", "chic", "plush", "calm",
  "sunny", "amber", "ivory", "sage", "coral", "indigo", "dusty", "muted", "polished", "refined",
  "breezy", "gentle", "snug", "elegant", "crisp", "mellow", "regal", "quaint", "bohemian", "nordic",
  "coastal", "alpine", "tuscan", "parisian", "scandi", "earthy", "woven", "marble", "oak", "walnut",
  "copper", "brass", "silken", "frosted", "gilded", "hushed", "dreamy", "lofty", "tranquil", "radiant",
];

export const USERNAME_NOUNS = [
  "loft", "studio", "atrium", "alcove", "parlor", "foyer", "terrace", "gallery", "suite", "nook",
  "haven", "manor", "villa", "cottage", "arch", "hearth", "garden", "palette", "canvas", "retreat",
  "abode", "chamber", "hall", "court", "veranda", "balcony", "library", "study", "lounge", "den",
  "attic", "pavilion", "cabin", "chalet", "penthouse", "sanctuary", "refuge", "harbor", "oasis", "glade",
  "grove", "vista", "mantel", "easel", "mosaic", "fresco", "motif", "accent", "weave", "thread",
  "room", "space", "corner", "dwelling",
];

const pick = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];

/**
 * Generate a memorable username like "cozy_loft_482".
 */
export function generateUsername(): string {
  const adj = pick(USERNAME_ADJECTIVES);
  const noun = pick(USERNAME_NOUNS);
  const num = Math.floor(Math.random() * 1000).toString().padStart(3, "0");
  return `${adj}_${noun}_${num}`;
}
